import { Fragment, type FC } from 'react';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { type AuditFormMechanicalEntryPageViewModel } from './audit-form-mechanical-entry-page.view-model';
import { AuditFormMechanicalEntryPageRenderer } from './audit-form-mechanical-entry-page.renderer';
import { DeleteConfirmationDialog } from '#packages/web/layouts/dialog/templates/delete-confirmation';

export type AuditFormMechanicalEntryPageContainerProps =
  ViewModelProps<AuditFormMechanicalEntryPageViewModel> & LoggingContext;

export const AuditFormMechanicalEntryPageContainer: FC<
  AuditFormMechanicalEntryPageContainerProps
> = ({ viewModel }) => {
  const {
    loadAuditFormState,
    updateMutationState,
    form,
    deleteDialog,
    onDelete,
    onSubmit,
  } = viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {loadAuditFormState.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {loadAuditFormState.state === 'success' && (
        <AuditFormMechanicalEntryPageRenderer
          changeRatingUnit={viewModel.changeRatingUnit}
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {/* Error */}
      {loadAuditFormState.state === 'error' && (
        <ThrowError error={loadAuditFormState.error} />
      )}

      {/* Mutation error */}
      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}

      {/* Delete Dialog */}
      {deleteDialog.isOpen && (
        <DeleteConfirmationDialog
          open
          onCancel={deleteDialog.close}
          onConfirm={onDelete.bind(null, { confirmed: true })}
        />
      )}
    </Fragment>
  );
};
